// The amenity categories and subcategories of osm.amenities (python/scripts/load_osm.lua),
// with the marker colour for each category. In its own module so the Redux slice can set
// its defaults without importing the layer or the icons.
export const AMENITY_CATEGORIES = [
    {name:'Food shopping', color:'#2e7d32', subcategories:['Supermarket', 'Convenience store', 'Frozen food', 'Greengrocer',
        'Butcher', 'Bakery', 'Deli', 'Fishmonger', 'Cheese shop', 'Farm shop', 'Organic shop', 'Market']},
    {name:'Eating out', color:'#ef6c00', subcategories:['Restaurant', 'Cafe', 'Takeaway', 'Food court', 'Ice cream']},
    {name:'Nightlife', color:'#ad1457', subcategories:['Pub', 'Bar', 'Beer garden', 'Club']},
    {name:'Shopping', color:'#00897b', subcategories:['Department store', 'Shopping centre', 'DIY store', 'Hardware store',
        'Garden centre', 'Chemist', 'Bookshop', 'Newsagent', 'Hairdresser']},
    {name:'Health', color:'#d32f2f', subcategories:['GP surgery', 'Pharmacy', 'Dentist', 'Clinic', 'Hospital', 'Vet']},
    {name:'Education', color:'#283593', subcategories:['Nursery', 'Childcare', 'School', 'College', 'University', 'Library']},
    {name:'Sport and leisure', color:'#0288d1', subcategories:['Gym', 'Sports centre', 'Swimming pool', 'Golf course',
        'Ice rink', 'Bowling', 'Water park']},
    {name:'Parks and outdoors', color:'#827717', subcategories:['Park', 'Playground', 'Nature reserve', 'Dog park', 'Allotments']},
    {name:'Culture', color:'#6a1b9a', subcategories:['Cinema', 'Theatre', 'Arts centre', 'Museum', 'Gallery']},
    {name:'Services', color:'#6d4c41', subcategories:['Post office', 'Bank', 'Police station', 'Fire station', 'Town hall',
        'Community centre', 'Place of worship']},
    {name:'Transport', color:'#37474f', subcategories:['Railway station', 'Tram stop', 'Bus station', 'Ferry terminal',
        'Bike hire', 'EV charging', 'Petrol station']},
];

export const AMENITY_CATEGORY_NAMES = AMENITY_CATEGORIES.map((c) => c.name);

export const amenityCategory = (name) => AMENITY_CATEGORIES.find((c) => c.name===name);

// subcategory -> its category's name
export const AMENITY_SUBCATEGORY_CATEGORY = Object.fromEntries(
    AMENITY_CATEGORIES.flatMap((c) => c.subcategories.map((s) => [s, c.name])));

// Shown when the layer is first added, as every category at once crowds the map. Every
// subcategory of these categories is on.
export const DEFAULT_AMENITY_CATEGORIES = ['Food shopping', 'Eating out', 'Shopping'];
export const DEFAULT_AMENITY_SUBCATEGORIES = AMENITY_CATEGORIES
    .filter((c) => DEFAULT_AMENITY_CATEGORIES.indexOf(c.name)>=0).flatMap((c) => c.subcategories);
